import { render } from "./wordleft.vue?vue&type=template&id=a27b29d0"
import script from "./wordleft.vue?vue&type=script&lang=js"
export * from "./wordleft.vue?vue&type=script&lang=js"

import "./wordleft.vue?vue&type=style&index=0&id=a27b29d0&lang=scss"

import exportComponent from "E:\\develop\\company\\gw\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__